class VariantSelects extends HTMLElement {
		constructor() {
			super();
			this.onVariantChange = this.onVariantChange.bind(this);
			this.addEventListener('change', this.onVariantChange);
		}

		connectedCallback() {
    console.log('[variant-selects] connected', {
      path: location.pathname,
      section: this.dataset.section,
      url: this.dataset.url
    });
  }
	
		onVariantChange() {
			this.updateOptions();
			this.updateMasterId();
			this.toggleAddButton(true, '', false);
			this.updatePickupAvailability();
			this.removeErrorMessage();
	
			if (!this.currentVariant) {
				this.toggleAddButton(true, '', true);
				this.setUnavailable();
			} else {
				// this.updateMedia();
				this.updateURL();
				this.updateVariantInput();
				this.renderProductInfo();
				this.updateShareUrl();
			}
		}
	
		updateOptions() {
			this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
		}
	
		updateMasterId() {
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options.map((option, index) => {
					return this.options[index] === option;
				}).includes(false);
			});
		}
	
		// updateMedia() {
		//   if (!this.currentVariant) return;
		//   if (!this.currentVariant.featured_media) return;
	
		//   const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
		//   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
	
		//   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
		//   if (!modalContent) return;
		//   const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
		//   modalContent.prepend(newMediaModal);
		// }
	
		updateURL() {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
			window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}
	
		updateShareUrl() {
			const shareButton = document.getElementById(`Share-${this.dataset.section}`);
			if (!shareButton || !shareButton.updateUrl) return;
			shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
		}
	
		updateVariantInput() {
			const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}
	
		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector('pickup-availability');
			if (!pickUpAvailability) return;
	
			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}
	
		removeErrorMessage() {
			const section = this.closest('section');
			if (!section) return;
	
			const productForm = section.querySelector('product-form');
			if (productForm) productForm.handleErrorMessage();
		}
	
		renderProductInfo() {
			fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html')
					const destination = document.getElementById(`price-${this.dataset.section}`);
					const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
					if (source && destination) destination.innerHTML = source.innerHTML;
	
					const price = document.getElementById(`price-${this.dataset.section}`);
				});
		}
	
		toggleAddButton(disable = true, text, modifyClass = true) {
			const productForm = document.getElementById(`product-form-${this.dataset.section}`);
			if (!productForm) return;
			const addButton = productForm.querySelector('[name="add"]');
			const addButtonText = productForm.querySelector('[name="add"] > span');
			if (!addButton) return;
	
			if (disable) {
				addButton.setAttribute('disabled', 'disabled');
				if (text) addButtonText.textContent = text;
			} else {
				addButton.removeAttribute('disabled');
				addButtonText.textContent = window.variantStrings.addToCart;
			}
	
			if (!modifyClass) return;
		}
	
		setUnavailable() {
			const button = document.getElementById(`product-form-${this.dataset.section}`);
			const addButton = button.querySelector('[name="add"]');
			const addButtonText = button.querySelector('[name="add"] > span');
			const price = document.getElementById(`price-${this.dataset.section}`);
			if (!addButton) return;
			addButtonText.textContent = window.variantStrings.unavailable;
			if (price) price.classList.add('visibility-hidden');
		}
	
		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
			return this.variantData;
		}
	}
	
	customElements.define('variant-selects', VariantSelects);
	
	class VariantRadios extends VariantSelects {
		constructor() {
			super();
		}
	
		updateOptions() {
			const fieldsets = Array.from(this.querySelectorAll('fieldset'));
			this.options = fieldsets.map((fs) => {
			const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
			const checked = radios.find(r => r.checked);
			const fallback = radios.find(r => !r.disabled) || radios[0];
			const chosen = checked || fallback;
			if (!chosen) {
				console.warn('[variant-radios] no radios found in a fieldset', fs);
				return '';
			}
			return chosen.value;
			});
		}
	}
	
	customElements.define('variant-radios', VariantRadios);

$(function () {
  if (window.matchMedia("(max-width: 768px)").matches) {
    $(document).on('click', '#scrollToElement', function () {
      const $target = $('#product-section__variant-buttons');
      if ($target.length) {
        const adjustedScrollPosition = $target.offset().top - 50;
        $('html, body').animate({ scrollTop: adjustedScrollPosition }, 400);
      }
    });

    var $b1 = $(".product-section__button-wrapper.mobile");
    var $b2 = $(".product-section__sticky-button");

    // Only start sticky for button 2 after the user scrolls
    let hasScrolled = $(window).scrollTop() > 0;
    $(window).one("scroll touchmove", function () {
      hasScrolled = true;
      requestAnimationFrame(update);
    });

    // --- Setup: only a spacer + cached naturalTop (no marker, no shim) ---
    function setup($btn) {
      if (!$btn.length) return null;

      var $spacer = $('<div class="sticky-spacer"></div>').css({
        display: "block",
        height: 0,
        margin: 0,
        padding: 0
      });
      $spacer.insertBefore($btn);

      // cache natural top while button is in normal flow
      var naturalTop = $btn.offset().top;

      return { $btn, $spacer, naturalTop, isPinned: false };
    }

    var s1 = setup($b1);
    var s2 = setup($b2);

    function refreshNaturalTop(S) {
      // Re-measure only when not pinned (i.e., in normal flow)
      if (!S) return;
      if (!S.isPinned) {
        S.naturalTop = S.$btn.offset().top;
      }
    }

    function pin(S) {
      if (!S) return;
      var h = S.$btn.outerHeight();
      S.$btn.css({ position: "fixed", bottom: "3%", left: 0, right: 0, zIndex: 999999 });
      S.$spacer.height(h);
      S.isPinned = true;
    }

    function release(S, endPosition) {
      if (!S) return;
      S.$btn.css({ position: endPosition || "static", bottom: "", left: "", right: "", zIndex: "" });
      S.$spacer.height(0);
      S.isPinned = false;
    }

    function naturalBottom(S) {
      return S.naturalTop + S.$btn.outerHeight();
    }

    function pinnedBottomPx() {
      return $(window).scrollTop() + window.innerHeight - window.innerHeight * 0.03; // 3% bottom
    }

    function update() {
      var pb = pinnedBottomPx();

      if (s1) refreshNaturalTop(s1);
      if (s2 && !hasScrolled) refreshNaturalTop(s2);

      // --- Button 1 ---
      if (s1) {
        var nb1 = naturalBottom(s1);
        if (pb >= nb1) {
          var endPos = $b1.has("#addToCart").length ? "inherit" : "static";
          release(s1, endPos);
        } else {
          if ($b1.has("#addToCart").length) pin(s1); else release(s1, "static");
        }
      }

      // --- Button 2 (only after first scroll) ---
      if (s2) {
        var nb2 = naturalBottom(s2);
        if (hasScrolled) {
          if (pb >= nb2) {
            release(s2, "inherit");
          } else {
            pin(s2);
          }
        } else {
          release(s2, "static"); // before scrolling, keep in flow
        }
      }
    }

    $(window).on("scroll resize orientationchange", update);
    setTimeout(update, 0);
    setTimeout(update, 300);
  }
});

const sizeGuideLink = document.querySelector('.size-guide-link');
const modal = document.querySelector('.modal-size');
const modalClose = document.querySelector('.close-modal');
const bodyLock = document.querySelector('body');
  
  // Check if both modal and modalClose elements exist
  if (modal && modalClose) {
    sizeGuideLink.addEventListener("click", function(e) {
      e.preventDefault(); // Changed 'event' to 'e' for consistency
      bodyLock.classList.add('_lock');
      modal.classList.add('active');
  
      // Close modal if the user clicks outside the modal content
      modal.addEventListener(
        "click",
        function(event) {
          if (!event.target.closest(".modal-content")) {
            closeModal();
          }
        },
        false
      );
      
      // Close modal when the close button is clicked
      modalClose.addEventListener("click", function() {
        closeModal();
      });
    });
  }
  
  // Function to close the modal
  function closeModal() {
    modal.classList.remove('active');
    bodyLock.classList.remove('_lock');
  }